module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/point01_01_travel-5b34b44eeeffa6fa5653a8c34bac1a43.jpg";